import {configureStore} from '@reduxjs/toolkit';

import contentReducer from './reducers/content';

export default configureStore({
  reducer: {
    content: contentReducer
  }
});